import { Component, Input, OnInit } from '@angular/core';
import { FormBuilderComponent } from '@/components/form-builder/form-builder.component';
import {
  DynamicFieldRepository,
  DynamicFieldRepositoryFactory,
  DynamicFieldStore,
} from '@/store/dynamic-form-state/dynamic-field-state/dynamic-field.repository';
import { getFormBuilderObjectFactory } from '@/components/form-builder/utils/form-builder-factory';
import { Observable } from 'rxjs';
import { getDynamicFieldFormObject } from './utils/dynamic-field.form-object';
import { FormType } from '@/types';

@Component({
  selector: 'sm-dynamic-field-form',
  imports: [FormBuilderComponent],
  templateUrl: './dynamic-field-form.component.html',
  styleUrl: './dynamic-field-form.component.scss',
})
export class DynamicFieldFormComponent implements OnInit {
  @Input() store?: DynamicFieldStore;
  @Input() isDisabled?: Observable<boolean>;
  @Input() formType?: Observable<FormType>;

  dynamicFieldsRepository?: DynamicFieldRepository;

  formObject = getFormBuilderObjectFactory();

  ngOnInit() {
    this.buildFormObject();
  }

  private buildFormObject() {
    if (this.store) {
      this.dynamicFieldsRepository = DynamicFieldRepositoryFactory.create(this.store);
      this.formObject = getDynamicFieldFormObject({
        store: this.dynamicFieldsRepository,
        formType: this.formType,
      });
    }
  }
}
